import { Dayjs } from 'dayjs';
import { JobDashboardRange } from '../job-dashboard/job-dashboard-configuration';
import { ResultFieldFilter } from '../job-result-analytics-dashboard/job-result-analytics-dashboard-configuration';

export interface DailyScanTimesDashboardConfiguration {
  title?: string;
  description?: string;
  dataConnectionIds?: string[];
  statuses?: string[];
  range: JobDashboardRange;
  sortOrder?: 'asc' | 'desc';
  from?: Dayjs;
  to?: Dayjs;
  /** JSON field on job result entries containing the scan timestamp (e.g. "scannedAt"). */
  scanTimestampFieldKey?: string;
  filters?: ResultFieldFilter[];
}

/** Maximum filters per request. Must match backend MAX_FILTERS. */
export const MAX_FILTERS = 10;

/** Maximum date range in days. Must match backend MAX_DATE_RANGE_DAYS (91 to account for timezone edge cases). */
export const MAX_DATE_RANGE_DAYS = 91;
